
Object.defineProperty(exports, "__esModule", { value: true });

const {
  Decimal,
  objectEnumValues,
  makeStrictEnum,
  Public,
  getRuntime,
  skip
} = require('@prisma/client/runtime/index-browser.js')


const Prisma = {}

exports.Prisma = Prisma
exports.$Enums = {}

/**
 * Prisma Client JS version: 5.20.0
 * Query Engine version: 06fc58a368dc7be9fbbbe894adf8d445d208c284
 */
Prisma.prismaVersion = {
  client: "5.20.0",
  engine: "06fc58a368dc7be9fbbbe894adf8d445d208c284"
}

Prisma.PrismaClientKnownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientKnownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)};
Prisma.PrismaClientUnknownRequestError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientUnknownRequestError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientRustPanicError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientRustPanicError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientInitializationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientInitializationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.PrismaClientValidationError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`PrismaClientValidationError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.NotFoundError = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`NotFoundError is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.Decimal = Decimal

/**
 * Re-export of sql-template-tag
 */
Prisma.sql = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`sqltag is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.empty = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`empty is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.join = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`join is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.raw = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`raw is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.validator = Public.validator

/**
* Extensions
*/
Prisma.getExtensionContext = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.getExtensionContext is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}
Prisma.defineExtension = () => {
  const runtimeName = getRuntime().prettyName;
  throw new Error(`Extensions.defineExtension is unable to run in this browser environment, or has been bundled for the browser (running in ${runtimeName}).
In case this error is unexpected for you, please report it in https://pris.ly/prisma-prisma-bug-report`,
)}

/**
 * Shorthand utilities for JSON filtering
 */
Prisma.DbNull = objectEnumValues.instances.DbNull
Prisma.JsonNull = objectEnumValues.instances.JsonNull
Prisma.AnyNull = objectEnumValues.instances.AnyNull

Prisma.NullTypes = {
  DbNull: objectEnumValues.classes.DbNull,
  JsonNull: objectEnumValues.classes.JsonNull,
  AnyNull: objectEnumValues.classes.AnyNull
}



/**
 * Enums
 */

exports.Prisma.TransactionIsolationLevel = makeStrictEnum({
  ReadUncommitted: 'ReadUncommitted',
  ReadCommitted: 'ReadCommitted',
  RepeatableRead: 'RepeatableRead',
  Serializable: 'Serializable'
});

exports.Prisma.UserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  email: 'email',
  hashedPassword: 'hashedPassword',
  role: 'role',
  isBotUser: 'isBotUser',
  image: 'image',
  twoFactorEnabled: 'twoFactorEnabled',
  emailVerified: 'emailVerified',
  crmMetadata: 'crmMetadata'
};

exports.Prisma.UserMarketingMetadataScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  metadata: 'metadata',
  userId: 'userId'
};

exports.Prisma.BotUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  userId: 'userId',
  authorizedSOAs: 'authorizedSOAs',
  accessToken: 'accessToken'
};

exports.Prisma.SessionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  expiresAt: 'expiresAt',
  handle: 'handle',
  hashedSessionToken: 'hashedSessionToken',
  antiCSRFToken: 'antiCSRFToken',
  publicData: 'publicData',
  privateData: 'privateData',
  userId: 'userId'
};

exports.Prisma.TokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  hashedToken: 'hashedToken',
  type: 'type',
  expiresAt: 'expiresAt',
  sentTo: 'sentTo',
  userId: 'userId'
};

exports.Prisma.MembershipTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  hashedToken: 'hashedToken',
  type: 'type',
  expiresAt: 'expiresAt',
  sentTo: 'sentTo',
  membershipId: 'membershipId',
  inviterId: 'inviterId'
};

exports.Prisma.OrganizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  hasOrderedIntegrationGift: 'hasOrderedIntegrationGift',
  stripeCustomer: 'stripeCustomer',
  stripeSubscription: 'stripeSubscription',
  lastUsageReportDate: 'lastUsageReportDate',
  trialEndDate: 'trialEndDate',
  billingType: 'billingType',
  localizationIntegration: 'localizationIntegration',
  crmMetadata: 'crmMetadata'
};

exports.Prisma.LocalizationProviderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  subtypeMigrationVersion: 'subtypeMigrationVersion',
  type: 'type',
  projectIdentifier: 'projectIdentifier',
  projectDisplayName: 'projectDisplayName',
  props: 'props',
  sourceLanguageLocale: 'sourceLanguageLocale',
  sourceLanguageDisplayName: 'sourceLanguageDisplayName',
  sourceLanguageProviderLanguageId: 'sourceLanguageProviderLanguageId',
  sourceLanguageIsRTL: 'sourceLanguageIsRTL',
  visibilitySince: 'visibilitySince',
  meta: 'meta',
  organizationId: 'organizationId'
};

exports.Prisma.LocalizationProviderSyncScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  endedAt: 'endedAt',
  succeeded: 'succeeded',
  message: 'message',
  keyCount: 'keyCount',
  updatedKeyCount: 'updatedKeyCount',
  localizationProviderId: 'localizationProviderId'
};

exports.Prisma.LocalizationProviderFilePathScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fileId: 'fileId',
  filePath: 'filePath',
  localizationProviderId: 'localizationProviderId'
};

exports.Prisma.LocalizationProviderKeyNameScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  keyId: 'keyId',
  fileId: 'fileId',
  keyName: 'keyName',
  localizationProviderId: 'localizationProviderId'
};

exports.Prisma.SWLocalization_ProjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  projectIdentifier: 'projectIdentifier',
  organizationId: 'organizationId'
};

exports.Prisma.SWLocalization_ProjectLanguageScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  locale: 'locale',
  projectIdentifier: 'projectIdentifier',
  organizationId: 'organizationId'
};

exports.Prisma.SWLocalization_KeyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  key: 'key',
  baseText: 'baseText',
  projectIdentifier: 'projectIdentifier',
  organizationId: 'organizationId'
};

exports.Prisma.SWLocalization_KeyTranslationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  translation: 'translation',
  keyId: 'keyId',
  locale: 'locale',
  projectIdentifier: 'projectIdentifier',
  organizationId: 'organizationId'
};

exports.Prisma.SuperwallLocalizationProviderScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  projectIdentifier: 'projectIdentifier',
  organizationId: 'organizationId'
};

exports.Prisma.OrganizationUsageRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  usageCount: 'usageCount',
  begin: 'begin',
  end: 'end',
  organizationId: 'organizationId'
};

exports.Prisma.ApplicationMarketingMetadataScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  metadata: 'metadata',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationAnalyticsMetadataScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sdkUpdateState: 'sdkUpdateState',
  topSDKVersion24h: 'topSDKVersion24h',
  topSDKVersion7d: 'topSDKVersion7d',
  latestSDKVersion7d: 'latestSDKVersion7d',
  releasesBehind: 'releasesBehind',
  onboardingSDKInstalled: 'onboardingSDKInstalled',
  onboardingSDKInstalledAt: 'onboardingSDKInstalledAt',
  onboardingPaywallPresented: 'onboardingPaywallPresented',
  onboardingPaywallPresentedAt: 'onboardingPaywallPresentedAt',
  onboardingTransactionCompleted: 'onboardingTransactionCompleted',
  onboardingTransactionCompletedAt: 'onboardingTransactionCompletedAt',
  onboardingProductsCreated: 'onboardingProductsCreated',
  onboardingProductsCreatedAt: 'onboardingProductsCreatedAt',
  onboardingProductsAddedToPaywall: 'onboardingProductsAddedToPaywall',
  onboardingProductsAddedToPaywallAt: 'onboardingProductsAddedToPaywallAt',
  onboardingCompleted: 'onboardingCompleted',
  onboardingCompletedAt: 'onboardingCompletedAt',
  onboardingProductionTransactionCompleted: 'onboardingProductionTransactionCompleted',
  onboardingProductionTransactionCompletedAt: 'onboardingProductionTransactionCompletedAt',
  transactions1d: 'transactions1d',
  transactions7d: 'transactions7d',
  transactionsPrevious7d: 'transactionsPrevious7d',
  transactionsPrevious7dDeltaAbsolute: 'transactionsPrevious7dDeltaAbsolute',
  transactionsPrevious7dDeltaPercentage: 'transactionsPrevious7dDeltaPercentage',
  transactions28d: 'transactions28d',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationUseageRecordScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  usageCount: 'usageCount',
  begin: 'begin',
  end: 'end',
  organizationUseageRecordId: 'organizationUseageRecordId',
  applicationId: 'applicationId'
};

exports.Prisma.OrganizationLocalizationTargetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  organizationId: 'organizationId',
  locale: 'locale'
};

exports.Prisma.MembershipScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  role: 'role',
  organizationId: 'organizationId',
  userId: 'userId',
  invitedName: 'invitedName',
  invitedEmail: 'invitedEmail'
};

exports.Prisma.ApplicationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  slug: 'slug',
  revenueCatPublicAPIKey: 'revenueCatPublicAPIKey',
  appStoreConnectSharedSecret: 'appStoreConnectSharedSecret',
  appId: 'appId',
  appleUrlScheme: 'appleUrlScheme',
  userAgentName: 'userAgentName',
  integrated: 'integrated',
  publicApiKey: 'publicApiKey',
  organizationId: 'organizationId',
  stripePrivateKey: 'stripePrivateKey',
  platform: 'platform',
  bundleId: 'bundleId',
  creatorId: 'creatorId',
  creatorEmail: 'creatorEmail',
  ignoreUsage: 'ignoreUsage',
  globallyDisabled: 'globallyDisabled',
  notificationRedirectUrl: 'notificationRedirectUrl',
  featuresEnabled: 'featuresEnabled',
  legacyPresentExperimentGroupId: 'legacyPresentExperimentGroupId',
  localizationProviderId: 'localizationProviderId',
  appleSmallBusinessStartDate: 'appleSmallBusinessStartDate',
  appleSmallBusinessEndDate: 'appleSmallBusinessEndDate',
  crmMetadata: 'crmMetadata'
};

exports.Prisma.ProjectScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  organizationId: 'organizationId'
};

exports.Prisma.ProjectApplicationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  projectId: 'projectId',
  applicationId: 'applicationId',
  platform: 'platform'
};

exports.Prisma.GloballyEnabledFeatureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.ApplicationAuthenticationTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  token: 'token',
  scopes: 'scopes',
  applicationId: 'applicationId'
};

exports.Prisma.IntegrationAuthenticationTokenScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  scope: 'scope',
  tokenPostfix: 'tokenPostfix',
  meta: 'meta'
};

exports.Prisma.ApplicationAsaConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  clientId: 'clientId',
  teamId: 'teamId',
  keyId: 'keyId',
  publicKey: 'publicKey',
  privateKey: 'privateKey',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationAssConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  bundleId: 'bundleId',
  keyId: 'keyId',
  issuerId: 'issuerId',
  privateKey: 'privateKey',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationAscConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  keyId: 'keyId',
  issuerId: 'issuerId',
  privateKey: 'privateKey',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationGPAuthConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  packageName: 'packageName',
  privateKey: 'privateKey',
  pubsubSubscriptionId: 'pubsubSubscriptionId',
  pubsubTopicName: 'pubsubTopicName',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationLiveStripeConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishableKey: 'publishableKey',
  secretKey: 'secretKey',
  webhookId: 'webhookId',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationTestStripeConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishableKey: 'publishableKey',
  secretKey: 'secretKey',
  webhookId: 'webhookId',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationLivePaddleConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishableKey: 'publishableKey',
  secretKey: 'secretKey',
  webhookId: 'webhookId',
  hostedCheckoutUrl: 'hostedCheckoutUrl',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationTestPaddleConfigurationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  publishableKey: 'publishableKey',
  secretKey: 'secretKey',
  webhookId: 'webhookId',
  hostedCheckoutUrl: 'hostedCheckoutUrl',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationSettingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  key: 'key',
  value: 'value',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationWebhookDestinationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  enabled: 'enabled',
  url: 'url',
  authorizationToken: 'authorizationToken',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationUserAttributeMappingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  mapping: 'mapping',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationConfigCacheScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productIdentifierGroups: 'productIdentifierGroups',
  enabledTriggerPaywalls: 'enabledTriggerPaywalls',
  enabledPaywalls: 'enabledPaywalls',
  eventNames: 'eventNames',
  applicationId: 'applicationId'
};

exports.Prisma.ShortLinkScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  url: 'url',
  slug: 'slug'
};

exports.Prisma.PaywallScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  migratedAt: 'migratedAt',
  inSuperwallWebflowAccount: 'inSuperwallWebflowAccount',
  name: 'name',
  slug: 'slug',
  url: 'url',
  substitutions: 'substitutions',
  requiredLocalizations: 'requiredLocalizations',
  pageStyles: 'pageStyles',
  manifest: 'manifest',
  products: 'products',
  ignoredLocalizations: 'ignoredLocalizations',
  primaryProductIdentifier: 'primaryProductIdentifier',
  secondaryProductIdentifier: 'secondaryProductIdentifier',
  tertiaryProductIdentifier: 'tertiaryProductIdentifier',
  presentationStyle: 'presentationStyle',
  backgroundColorHex: 'backgroundColorHex',
  darkBackgroundColorHex: 'darkBackgroundColorHex',
  showPaywallOption: 'showPaywallOption',
  paywallDismissal: 'paywallDismissal',
  presentationCondition: 'presentationCondition',
  applicationId: 'applicationId',
  enabled: 'enabled',
  templateJson: 'templateJson',
  localNotifications: 'localNotifications',
  featureGating: 'featureGating',
  onDeviceCache: 'onDeviceCache',
  isScrollEnabled: 'isScrollEnabled',
  reRouteBackButton: 'reRouteBackButton',
  gameControllerSupport: 'gameControllerSupport',
  templateType: 'templateType',
  templateId: 'templateId',
  sourcePaywallId: 'sourcePaywallId',
  surveyId: 'surveyId',
  v4: 'v4',
  deployedPaywallVersionId: 'deployedPaywallVersionId'
};

exports.Prisma.PaywallResourceRequirementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  paywallResourceId: 'paywallResourceId',
  paywallId: 'paywallId'
};

exports.Prisma.PaywallVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  editable: 'editable',
  title: 'title',
  description: 'description',
  paywallId: 'paywallId'
};

exports.Prisma.PaywallSnapshotScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  storageKey: 'storageKey',
  url: 'url',
  data: 'data',
  paywallVersionId: 'paywallVersionId'
};

exports.Prisma.PaywallResourcePaywallVersionRequirementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  scope: 'scope',
  type: 'type',
  organizationId: 'organizationId',
  paywallVersionId: 'paywallVersionId'
};

exports.Prisma.PaywallResourcePaywallVersionVarintFixtureScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  scope: 'scope',
  type: 'type',
  organizationId: 'organizationId',
  paywallVersionId: 'paywallVersionId',
  variant: 'variant'
};

exports.Prisma.PaywallResourceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  description: 'description',
  metadata: 'metadata',
  scope: 'scope',
  type: 'type',
  organizationId: 'organizationId'
};

exports.Prisma.TextPaywallResourceVersionRequirementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  keyId: 'keyId',
  version: 'version',
  localizationProviderId: 'localizationProviderId',
  paywallSnapshotId: 'paywallSnapshotId',
  paywallVersionId: 'paywallVersionId'
};

exports.Prisma.TextPaywallResourceVersionVariantRequirementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  keyId: 'keyId',
  version: 'version',
  variantVersion: 'variantVersion',
  variant: 'variant',
  localizationProviderId: 'localizationProviderId',
  paywallSnapshotId: 'paywallSnapshotId'
};

exports.Prisma.PaywallLanguageRequirementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  language: 'language',
  paywallSnapshotId: 'paywallSnapshotId'
};

exports.Prisma.TextPaywallResourceScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  localizationProviderId: 'localizationProviderId',
  keyId: 'keyId',
  visibilitySince: 'visibilitySince',
  deletedAt: 'deletedAt'
};

exports.Prisma.TextPaywallResourceVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  localizationProviderId: 'localizationProviderId',
  keyId: 'keyId',
  version: 'version',
  text: 'text',
  isDeleted: 'isDeleted'
};

exports.Prisma.TextPaywallResourceVersionVariantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  localizationProviderId: 'localizationProviderId',
  keyId: 'keyId',
  version: 'version',
  variant: 'variant'
};

exports.Prisma.TextPaywallResourceVersionVariantVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  localizationProviderId: 'localizationProviderId',
  keyId: 'keyId',
  version: 'version',
  variant: 'variant',
  variantVersion: 'variantVersion',
  text: 'text',
  status: 'status'
};

exports.Prisma.PaywallResourceVersionScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  version: 'version',
  releaseNotes: 'releaseNotes',
  snapshot: 'snapshot',
  storageKey: 'storageKey',
  previewUrl: 'previewUrl',
  paywallResourceId: 'paywallResourceId'
};

exports.Prisma.PaywallResourceVersionVariantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  snapshot: 'snapshot',
  storageKey: 'storageKey',
  variant: 'variant',
  paywallResourceVersionId: 'paywallResourceVersionId'
};

exports.Prisma.PaywallSurveyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  surveyId: 'surveyId',
  surveyPresentationCondition: 'surveyPresentationCondition',
  paywallId: 'paywallId'
};

exports.Prisma.PaywallPreviewScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  active: 'active',
  url: 'url',
  identifier: 'identifier',
  paywallId: 'paywallId',
  paywallResponse: 'paywallResponse'
};

exports.Prisma.PaywallLocalizationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  locale: 'locale',
  substitutions: 'substitutions',
  paywallId: 'paywallId'
};

exports.Prisma.LocalizableStringScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  string: 'string',
  organizationId: 'organizationId'
};

exports.Prisma.PaywallLocalizableStringRequirementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  localizableStringId: 'localizableStringId',
  paywallId: 'paywallId'
};

exports.Prisma.LocalizedStringScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  string: 'string',
  locale: 'locale',
  localizableStringId: 'localizableStringId'
};

exports.Prisma.PaywallTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  eventName: 'eventName',
  enabled: 'enabled',
  paywallId: 'paywallId',
  applicationId: 'applicationId',
  triggerExperimentGroupId: 'triggerExperimentGroupId'
};

exports.Prisma.WebPaywallTriggerScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  name: 'name',
  enabled: 'enabled',
  urlMatchingString: 'urlMatchingString',
  elementSelector: 'elementSelector',
  elementSelectorType: 'elementSelectorType',
  pageLoadDelayMs: 'pageLoadDelayMs',
  triggerType: 'triggerType',
  setupUrl: 'setupUrl',
  applicationId: 'applicationId',
  webPaywallId: 'webPaywallId'
};

exports.Prisma.WebPaywallScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  identifier: 'identifier',
  name: 'name',
  url: 'url',
  substitutions: 'substitutions',
  primaryProductId: 'primaryProductId',
  applicationId: 'applicationId'
};

exports.Prisma.WebProductScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  stripeProductId: 'stripeProductId',
  applicationId: 'applicationId',
  prices: 'prices'
};

exports.Prisma.StripeProductRankingScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  stripeProductId: 'stripeProductId',
  applicationId: 'applicationId',
  ranking: 'ranking'
};

exports.Prisma.TriggerExperimentGroupScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  description: 'description',
  applicationId: 'applicationId',
  isLegacyPresent: 'isLegacyPresent'
};

exports.Prisma.ApplicationUserScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  applicationId: 'applicationId',
  properties: 'properties',
  propertiesHash: 'propertiesHash',
  paywallId: 'paywallId',
  billableUser: 'billableUser',
  notificationNodeId: 'notificationNodeId',
  notificationNodeMergentTaskId: 'notificationNodeMergentTaskId',
  notificationNodeAssignedAt: 'notificationNodeAssignedAt'
};

exports.Prisma.ApplicationUserNotificationV2AssigmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  timelineCompletedAt: 'timelineCompletedAt',
  processLeaseEndAt: 'processLeaseEndAt',
  processId: 'processId',
  enteredAt: 'enteredAt',
  notificationNodeV2Id: 'notificationNodeV2Id',
  applicationUserId: 'applicationUserId'
};

exports.Prisma.ApplicationUserAliasScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  appUserId: 'appUserId',
  applicationUserId: 'applicationUserId',
  applicationId: 'applicationId'
};

exports.Prisma.ApplicationUserEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  eventName: 'eventName',
  eventParameters: 'eventParameters',
  applicationUserAliasId: 'applicationUserAliasId'
};

exports.Prisma.CustomerDomainScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  fqdn: 'fqdn',
  slug: 'slug',
  organizationId: 'organizationId'
};

exports.Prisma.StandardEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name'
};

exports.Prisma.StorageBlobScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  bucket: 'bucket',
  key: 'key',
  filename: 'filename',
  metadata: 'metadata',
  organizationId: 'organizationId'
};

exports.Prisma.LocalizationFileUploadScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  status: 'status',
  locale: 'locale',
  blobId: 'blobId',
  organizationId: 'organizationId'
};

exports.Prisma.NotificationTimelineScalarFieldEnum = {
  id: 'id',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  applicationId: 'applicationId'
};

exports.Prisma.NotificationTimelineV2ScalarFieldEnum = {
  id: 'id',
  archivedAt: 'archivedAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  notificationGraph: 'notificationGraph',
  applicationId: 'applicationId'
};

exports.Prisma.NotificationNodeV2ScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  notificationTimelineV2Id: 'notificationTimelineV2Id',
  delaySeconds: 'delaySeconds'
};

exports.Prisma.NotificationNodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  delaySeconds: 'delaySeconds',
  notificationTimelineId: 'notificationTimelineId',
  nextNodeId: 'nextNodeId'
};

exports.Prisma.NotificationPlanScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  planType: 'planType',
  planParameters: 'planParameters',
  sortOrder: 'sortOrder',
  notificationNodeId: 'notificationNodeId'
};

exports.Prisma.ProductScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  identifier: 'identifier',
  platform: 'platform',
  rawPrice: 'rawPrice',
  rawTrialPeriodPrice: 'rawTrialPeriodPrice',
  trialPeriodDays: 'trialPeriodDays',
  period: 'period',
  identifierRC: 'identifierRC',
  applicationId: 'applicationId'
};

exports.Prisma.ProductEntitlementsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  productId: 'productId',
  entitlementId: 'entitlementId'
};

exports.Prisma.EntitlementScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  identifier: 'identifier',
  type: 'type',
  applicationId: 'applicationId'
};

exports.Prisma.LocalizedProductScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  locale: 'locale',
  language: 'language',
  region: 'region',
  currency: 'currency',
  productObjectHash: 'productObjectHash',
  productObject: 'productObject',
  productId: 'productId'
};

exports.Prisma.TriggerExperimentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  expression: 'expression',
  expressionOccurrenceKey: 'expressionOccurrenceKey',
  useV2Editor: 'useV2Editor',
  ruleConditions: 'ruleConditions',
  interval: 'interval',
  occurrences: 'occurrences',
  rank: 'rank',
  description: 'description',
  enabled: 'enabled',
  experimentId: 'experimentId',
  triggerExperimentGroupId: 'triggerExperimentGroupId',
  variantOptimization: 'variantOptimization',
  templateType: 'templateType'
};

exports.Prisma.ExperimentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  applicationId: 'applicationId'
};

exports.Prisma.VariantScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  foreignKey: 'foreignKey',
  foreignKeyType: 'foreignKeyType',
  variantType: 'variantType',
  percentage: 'percentage',
  experimentId: 'experimentId'
};

exports.Prisma.AssignmentScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAtUnix: 'deletedAtUnix',
  applicationUserId: 'applicationUserId',
  variantId: 'variantId',
  experimentId: 'experimentId',
  replicatedToClickhouse: 'replicatedToClickhouse'
};

exports.Prisma.PaywallAssetScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  applicationId: 'applicationId',
  key: 'key',
  name: 'name',
  attributes: 'attributes'
};

exports.Prisma.ApplicationETLDestinationScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  applicationId: 'applicationId',
  compression: 'compression',
  endpointUrl: 'endpointUrl',
  bucket: 'bucket',
  accessKeyId: 'accessKeyId',
  secretAccessKey: 'secretAccessKey'
};

exports.Prisma.SDKConfigurationToggleScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  applicationId: 'applicationId',
  key: 'key',
  enabled: 'enabled'
};

exports.Prisma.ApplicationSettingsScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  applicationId: 'applicationId',
  settings: 'settings'
};

exports.Prisma.ChatOpsSettingsScalarFieldEnum = {
  id: 'id',
  settings: 'settings'
};

exports.Prisma.PaywallTemplateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  applicationId: 'applicationId',
  key: 'key',
  json: 'json'
};

exports.Prisma.SurveyScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  archivedAt: 'archivedAt',
  name: 'name',
  applicationId: 'applicationId',
  assignmentKey: 'assignmentKey',
  title: 'title',
  message: 'message',
  options: 'options',
  includeOtherOption: 'includeOtherOption',
  includeCloseOption: 'includeCloseOption',
  presentationProbability: 'presentationProbability'
};

exports.Prisma.StaffBarKVScalarFieldEnum = {
  key: 'key',
  value: 'value'
};

exports.Prisma.StorefrontCurrencyPriceInfoScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  storefront: 'storefront',
  currency: 'currency',
  customerPrice: 'customerPrice',
  proceeds: 'proceeds',
  proceedsYear2: 'proceedsYear2'
};

exports.Prisma.CurrencyExchangeRateScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  sourceCurrency: 'sourceCurrency',
  targetCurrency: 'targetCurrency',
  rate: 'rate'
};

exports.Prisma.SubscriptionEventScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  name: 'name',
  applicationId: 'applicationId',
  organizationId: 'organizationId',
  appUserId: 'appUserId',
  applicationUserId: 'applicationUserId',
  vendorId: 'vendorId',
  sdkVersion: 'sdkVersion',
  appVersion: 'appVersion',
  userProperties: 'userProperties',
  source: 'source',
  integration: 'integration',
  store: 'store',
  experimentId: 'experimentId',
  variantId: 'variantId',
  paywallId: 'paywallId',
  transactionCompleteEventDate: 'transactionCompleteEventDate',
  installDate: 'installDate',
  transactionId: 'transactionId',
  originalTransactionId: 'originalTransactionId',
  price: 'price',
  priceInPurchasedCurrency: 'priceInPurchasedCurrency',
  proceeds: 'proceeds',
  productId: 'productId',
  periodType: 'periodType',
  isTrialConversion: 'isTrialConversion',
  takehomePercentage: 'takehomePercentage',
  commissionPercentage: 'commissionPercentage',
  taxPercentage: 'taxPercentage',
  timestamp: 'timestamp',
  environment: 'environment',
  newProductId: 'newProductId',
  purchasedAt: 'purchasedAt',
  expirationAt: 'expirationAt',
  cancelReason: 'cancelReason',
  isFamilyShare: 'isFamilyShare',
  isSmallBusiness: 'isSmallBusiness',
  isRefund: 'isRefund',
  countryCode: 'countryCode',
  currencyCode: 'currencyCode',
  offerCode: 'offerCode',
  exchangeRate: 'exchangeRate',
  placement: 'placement',
  deploymentVersion: 'deploymentVersion'
};

exports.Prisma.OAuth2AuthorizationCodeScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  expiresAt: 'expiresAt',
  authorizationCode: 'authorizationCode',
  redirectUri: 'redirectUri',
  scope: 'scope',
  codeChallenge: 'codeChallenge',
  codeChallengeMethod: 'codeChallengeMethod',
  clientId: 'clientId',
  userId: 'userId'
};

exports.Prisma.OAuth2AccessTokenScalarFieldEnum = {
  id: 'id',
  accessToken: 'accessToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  scope: 'scope',
  clientId: 'clientId',
  userId: 'userId'
};

exports.Prisma.WebPaywallDomainScalarFieldEnum = {
  id: 'id',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  deletedAt: 'deletedAt',
  domain: 'domain',
  applicationId: 'applicationId'
};

exports.Prisma.AccountsAccountScalarFieldEnum = {
  id: 'id',
  accountId: 'accountId',
  providerId: 'providerId',
  userId: 'userId',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  idToken: 'idToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  scope: 'scope',
  password: 'password',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountsJwksScalarFieldEnum = {
  id: 'id',
  publicKey: 'publicKey',
  privateKey: 'privateKey',
  createdAt: 'createdAt'
};

exports.Prisma.AccountsOauthAccessTokenScalarFieldEnum = {
  id: 'id',
  accessToken: 'accessToken',
  refreshToken: 'refreshToken',
  accessTokenExpiresAt: 'accessTokenExpiresAt',
  refreshTokenExpiresAt: 'refreshTokenExpiresAt',
  clientId: 'clientId',
  userId: 'userId',
  scopes: 'scopes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountsOauthApplicationScalarFieldEnum = {
  id: 'id',
  name: 'name',
  icon: 'icon',
  metadata: 'metadata',
  clientId: 'clientId',
  clientSecret: 'clientSecret',
  redirectUrls: 'redirectUrls',
  type: 'type',
  disabled: 'disabled',
  userId: 'userId',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.AccountsOauthConsentScalarFieldEnum = {
  id: 'id',
  clientId: 'clientId',
  userId: 'userId',
  scopes: 'scopes',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  consentGiven: 'consentGiven'
};

exports.Prisma.AccountsPasskeyScalarFieldEnum = {
  id: 'id',
  name: 'name',
  publicKey: 'publicKey',
  userId: 'userId',
  credentialId: 'credentialId',
  counter: 'counter',
  deviceType: 'deviceType',
  backedUp: 'backedUp',
  transports: 'transports',
  createdAt: 'createdAt'
};

exports.Prisma.AccountsSessionScalarFieldEnum = {
  id: 'id',
  expiresAt: 'expiresAt',
  token: 'token',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt',
  ipAddress: 'ipAddress',
  userAgent: 'userAgent',
  userId: 'userId'
};

exports.Prisma.AccountsTwoFactorScalarFieldEnum = {
  id: 'id',
  secret: 'secret',
  backupCodes: 'backupCodes',
  userId: 'userId'
};

exports.Prisma.AccountsVerificationScalarFieldEnum = {
  id: 'id',
  identifier: 'identifier',
  value: 'value',
  expiresAt: 'expiresAt',
  createdAt: 'createdAt',
  updatedAt: 'updatedAt'
};

exports.Prisma.SortOrder = {
  asc: 'asc',
  desc: 'desc'
};

exports.Prisma.NullableJsonNullValueInput = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueInput = {
  JsonNull: Prisma.JsonNull
};

exports.Prisma.JsonNullValueFilter = {
  DbNull: Prisma.DbNull,
  JsonNull: Prisma.JsonNull,
  AnyNull: Prisma.AnyNull
};

exports.Prisma.NullsOrder = {
  first: 'first',
  last: 'last'
};
exports.GlobalRole = exports.$Enums.GlobalRole = {
  SUPERADMIN: 'SUPERADMIN',
  CUSTOMER: 'CUSTOMER'
};

exports.TokenType = exports.$Enums.TokenType = {
  RESET_PASSWORD: 'RESET_PASSWORD'
};

exports.MembershipTokenType = exports.$Enums.MembershipTokenType = {
  INVITE: 'INVITE'
};

exports.OrganizationBillingType = exports.$Enums.OrganizationBillingType = {
  STANDARD: 'STANDARD',
  AD_HOC_CUSTOM: 'AD_HOC_CUSTOM'
};

exports.MembershipRole = exports.$Enums.MembershipRole = {
  OWNER: 'OWNER',
  ADMIN: 'ADMIN',
  USER: 'USER',
  EDITOR: 'EDITOR',
  READER: 'READER',
  ANALYST: 'ANALYST'
};

exports.ApplicationPlatform = exports.$Enums.ApplicationPlatform = {
  IOS: 'IOS',
  ANDROID: 'ANDROID',
  WEB: 'WEB',
  STRIPE: 'STRIPE',
  PADDLE: 'PADDLE'
};

exports.PaywallPresentationStyle = exports.$Enums.PaywallPresentationStyle = {
  FULLSCREEN: 'FULLSCREEN',
  MODAL: 'MODAL',
  PUSH: 'PUSH',
  NO_ANIMATION: 'NO_ANIMATION',
  DRAWER: 'DRAWER'
};

exports.ShowPaywallOption = exports.$Enums.ShowPaywallOption = {
  EXPLICIT: 'EXPLICIT',
  ON_FIRST_LAUNCH: 'ON_FIRST_LAUNCH',
  ON_NTH_LAUNCH: 'ON_NTH_LAUNCH'
};

exports.PaywallDismissal = exports.$Enums.PaywallDismissal = {
  NORMAL: 'NORMAL',
  DISABLED: 'DISABLED'
};

exports.PresentationCondition = exports.$Enums.PresentationCondition = {
  CHECK_USER_SUBSCRIPTION: 'CHECK_USER_SUBSCRIPTION',
  ALWAYS: 'ALWAYS'
};

exports.FeatureGating = exports.$Enums.FeatureGating = {
  GATED: 'GATED',
  NON_GATED: 'NON_GATED'
};

exports.OnDeviceCache = exports.$Enums.OnDeviceCache = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
};

exports.IsScrollEnabled = exports.$Enums.IsScrollEnabled = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
};

exports.ReRouteBackButton = exports.$Enums.ReRouteBackButton = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
};

exports.GameControllerSupport = exports.$Enums.GameControllerSupport = {
  ENABLED: 'ENABLED',
  DISABLED: 'DISABLED'
};

exports.PaywallTemplateType = exports.$Enums.PaywallTemplateType = {
  GLOBAL: 'GLOBAL',
  UNLISTED: 'UNLISTED',
  ORGANIZATION: 'ORGANIZATION'
};

exports.TextPaywallResourceVersionVariantVersionStatus = exports.$Enums.TextPaywallResourceVersionVariantVersionStatus = {
  UNVERIFIED: 'UNVERIFIED',
  NORMAL: 'NORMAL',
  REVIEWED: 'REVIEWED'
};

exports.SurveyPresentationCondition = exports.$Enums.SurveyPresentationCondition = {
  ON_MANUAL_CLOSE: 'ON_MANUAL_CLOSE',
  ON_PURCHASE: 'ON_PURCHASE'
};

exports.ElementSelectorType = exports.$Enums.ElementSelectorType = {
  CSS: 'CSS',
  TEXT: 'TEXT'
};

exports.WebPaywallTriggerType = exports.$Enums.WebPaywallTriggerType = {
  ON_LOAD: 'ON_LOAD',
  ON_ELEMENT_CLICK: 'ON_ELEMENT_CLICK'
};

exports.ApplicationUserEventName = exports.$Enums.ApplicationUserEventName = {
  ALIASED: 'ALIASED',
  PAYWALL_ASSIGNED: 'PAYWALL_ASSIGNED'
};

exports.LocalizationFileUploadStatus = exports.$Enums.LocalizationFileUploadStatus = {
  STARTING: 'STARTING',
  COMPLETED: 'COMPLETED',
  FAILED: 'FAILED'
};

exports.NotificationPlanType = exports.$Enums.NotificationPlanType = {
  SMS: 'SMS',
  EMAIL: 'EMAIL',
  PUSH: 'PUSH'
};

exports.Platform = exports.$Enums.Platform = {
  IOS: 'IOS'
};

exports.EntitlementType = exports.$Enums.EntitlementType = {
  SERVICE_LEVEL: 'SERVICE_LEVEL'
};

exports.TriggerExperimentVariantOptimization = exports.$Enums.TriggerExperimentVariantOptimization = {
  NONE: 'NONE',
  UCB1_BANDIT: 'UCB1_BANDIT'
};

exports.TriggerExperimentTemplateType = exports.$Enums.TriggerExperimentTemplateType = {
  GLOBAL: 'GLOBAL',
  ORGANIZATION: 'ORGANIZATION'
};

exports.PolymorphicRelationType = exports.$Enums.PolymorphicRelationType = {
  NONE: 'NONE',
  PAYWALL: 'PAYWALL',
  TRIGGER: 'TRIGGER'
};

exports.VariantType = exports.$Enums.VariantType = {
  HOLDOUT: 'HOLDOUT',
  TREATMENT: 'TREATMENT'
};

exports.ETLDestinationCompression = exports.$Enums.ETLDestinationCompression = {
  NONE: 'NONE',
  GZIP: 'GZIP'
};

exports.SubscriptionEventStore = exports.$Enums.SubscriptionEventStore = {
  APP_STORE: 'APP_STORE',
  GOOGLE_PLAY: 'GOOGLE_PLAY',
  STRIPE: 'STRIPE'
};

exports.SubscriptionEventPeriodType = exports.$Enums.SubscriptionEventPeriodType = {
  NORMAL: 'NORMAL',
  TRIAL: 'TRIAL',
  INTRO: 'INTRO',
  PROMO: 'PROMO',
  PREPAID: 'PREPAID',
  PROMOTIONAL: 'PROMOTIONAL'
};

exports.SubscriptionEventEnvironment = exports.$Enums.SubscriptionEventEnvironment = {
  PRODUCTION: 'PRODUCTION',
  SANDBOX: 'SANDBOX'
};

exports.SubscriptionEventCancelReason = exports.$Enums.SubscriptionEventCancelReason = {
  UNSUBSCRIBE: 'UNSUBSCRIBE',
  BILLING_ERROR: 'BILLING_ERROR',
  DEVELOPER_INITIATED: 'DEVELOPER_INITIATED',
  PRICE_INCREASE: 'PRICE_INCREASE',
  CUSTOMER_SUPPORT: 'CUSTOMER_SUPPORT',
  UNKNOWN: 'UNKNOWN'
};

exports.Prisma.ModelName = {
  User: 'User',
  UserMarketingMetadata: 'UserMarketingMetadata',
  BotUser: 'BotUser',
  Session: 'Session',
  Token: 'Token',
  MembershipToken: 'MembershipToken',
  Organization: 'Organization',
  LocalizationProvider: 'LocalizationProvider',
  LocalizationProviderSync: 'LocalizationProviderSync',
  LocalizationProviderFilePath: 'LocalizationProviderFilePath',
  LocalizationProviderKeyName: 'LocalizationProviderKeyName',
  SWLocalization_Project: 'SWLocalization_Project',
  SWLocalization_ProjectLanguage: 'SWLocalization_ProjectLanguage',
  SWLocalization_Key: 'SWLocalization_Key',
  SWLocalization_KeyTranslation: 'SWLocalization_KeyTranslation',
  SuperwallLocalizationProvider: 'SuperwallLocalizationProvider',
  OrganizationUsageRecord: 'OrganizationUsageRecord',
  ApplicationMarketingMetadata: 'ApplicationMarketingMetadata',
  ApplicationAnalyticsMetadata: 'ApplicationAnalyticsMetadata',
  ApplicationUseageRecord: 'ApplicationUseageRecord',
  OrganizationLocalizationTarget: 'OrganizationLocalizationTarget',
  Membership: 'Membership',
  Application: 'Application',
  Project: 'Project',
  ProjectApplication: 'ProjectApplication',
  GloballyEnabledFeature: 'GloballyEnabledFeature',
  ApplicationAuthenticationToken: 'ApplicationAuthenticationToken',
  IntegrationAuthenticationToken: 'IntegrationAuthenticationToken',
  ApplicationAsaConfiguration: 'ApplicationAsaConfiguration',
  ApplicationAssConfiguration: 'ApplicationAssConfiguration',
  ApplicationAscConfiguration: 'ApplicationAscConfiguration',
  ApplicationGPAuthConfiguration: 'ApplicationGPAuthConfiguration',
  ApplicationLiveStripeConfiguration: 'ApplicationLiveStripeConfiguration',
  ApplicationTestStripeConfiguration: 'ApplicationTestStripeConfiguration',
  ApplicationLivePaddleConfiguration: 'ApplicationLivePaddleConfiguration',
  ApplicationTestPaddleConfiguration: 'ApplicationTestPaddleConfiguration',
  ApplicationSetting: 'ApplicationSetting',
  ApplicationWebhookDestination: 'ApplicationWebhookDestination',
  ApplicationUserAttributeMapping: 'ApplicationUserAttributeMapping',
  ApplicationConfigCache: 'ApplicationConfigCache',
  ShortLink: 'ShortLink',
  Paywall: 'Paywall',
  PaywallResourceRequirement: 'PaywallResourceRequirement',
  PaywallVersion: 'PaywallVersion',
  PaywallSnapshot: 'PaywallSnapshot',
  PaywallResourcePaywallVersionRequirement: 'PaywallResourcePaywallVersionRequirement',
  PaywallResourcePaywallVersionVarintFixture: 'PaywallResourcePaywallVersionVarintFixture',
  PaywallResource: 'PaywallResource',
  TextPaywallResourceVersionRequirement: 'TextPaywallResourceVersionRequirement',
  TextPaywallResourceVersionVariantRequirement: 'TextPaywallResourceVersionVariantRequirement',
  PaywallLanguageRequirement: 'PaywallLanguageRequirement',
  TextPaywallResource: 'TextPaywallResource',
  TextPaywallResourceVersion: 'TextPaywallResourceVersion',
  TextPaywallResourceVersionVariant: 'TextPaywallResourceVersionVariant',
  TextPaywallResourceVersionVariantVersion: 'TextPaywallResourceVersionVariantVersion',
  PaywallResourceVersion: 'PaywallResourceVersion',
  PaywallResourceVersionVariant: 'PaywallResourceVersionVariant',
  PaywallSurvey: 'PaywallSurvey',
  PaywallPreview: 'PaywallPreview',
  PaywallLocalization: 'PaywallLocalization',
  LocalizableString: 'LocalizableString',
  PaywallLocalizableStringRequirement: 'PaywallLocalizableStringRequirement',
  LocalizedString: 'LocalizedString',
  PaywallTrigger: 'PaywallTrigger',
  WebPaywallTrigger: 'WebPaywallTrigger',
  WebPaywall: 'WebPaywall',
  WebProduct: 'WebProduct',
  StripeProductRanking: 'StripeProductRanking',
  TriggerExperimentGroup: 'TriggerExperimentGroup',
  ApplicationUser: 'ApplicationUser',
  ApplicationUserNotificationV2Assigment: 'ApplicationUserNotificationV2Assigment',
  ApplicationUserAlias: 'ApplicationUserAlias',
  ApplicationUserEvent: 'ApplicationUserEvent',
  CustomerDomain: 'CustomerDomain',
  StandardEvent: 'StandardEvent',
  StorageBlob: 'StorageBlob',
  LocalizationFileUpload: 'LocalizationFileUpload',
  NotificationTimeline: 'NotificationTimeline',
  NotificationTimelineV2: 'NotificationTimelineV2',
  NotificationNodeV2: 'NotificationNodeV2',
  NotificationNode: 'NotificationNode',
  NotificationPlan: 'NotificationPlan',
  Product: 'Product',
  ProductEntitlements: 'ProductEntitlements',
  Entitlement: 'Entitlement',
  LocalizedProduct: 'LocalizedProduct',
  TriggerExperiment: 'TriggerExperiment',
  Experiment: 'Experiment',
  Variant: 'Variant',
  Assignment: 'Assignment',
  PaywallAsset: 'PaywallAsset',
  ApplicationETLDestination: 'ApplicationETLDestination',
  SDKConfigurationToggle: 'SDKConfigurationToggle',
  ApplicationSettings: 'ApplicationSettings',
  ChatOpsSettings: 'ChatOpsSettings',
  PaywallTemplate: 'PaywallTemplate',
  Survey: 'Survey',
  StaffBarKV: 'StaffBarKV',
  StorefrontCurrencyPriceInfo: 'StorefrontCurrencyPriceInfo',
  CurrencyExchangeRate: 'CurrencyExchangeRate',
  SubscriptionEvent: 'SubscriptionEvent',
  OAuth2AuthorizationCode: 'OAuth2AuthorizationCode',
  OAuth2AccessToken: 'OAuth2AccessToken',
  WebPaywallDomain: 'WebPaywallDomain',
  AccountsAccount: 'AccountsAccount',
  AccountsJwks: 'AccountsJwks',
  AccountsOauthAccessToken: 'AccountsOauthAccessToken',
  AccountsOauthApplication: 'AccountsOauthApplication',
  AccountsOauthConsent: 'AccountsOauthConsent',
  AccountsPasskey: 'AccountsPasskey',
  AccountsSession: 'AccountsSession',
  AccountsTwoFactor: 'AccountsTwoFactor',
  AccountsVerification: 'AccountsVerification'
};

/**
 * This is a stub Prisma Client that will error at runtime if called.
 */
class PrismaClient {
  constructor() {
    return new Proxy(this, {
      get(target, prop) {
        let message
        const runtime = getRuntime()
        if (runtime.isEdge) {
          message = `PrismaClient is not configured to run in ${runtime.prettyName}. In order to run Prisma Client on edge runtime, either:
- Use Prisma Accelerate: https://pris.ly/d/accelerate
- Use Driver Adapters: https://pris.ly/d/driver-adapters
`;
        } else {
          message = 'PrismaClient is unable to run in this browser environment, or has been bundled for the browser (running in `' + runtime.prettyName + '`).'
        }
        
        message += `
If this is unexpected, please open an issue: https://pris.ly/prisma-prisma-bug-report`

        throw new Error(message)
      }
    })
  }
}

exports.PrismaClient = PrismaClient

Object.assign(exports, Prisma)
